<div class="modal-header bg-head-realtion py-2">
  <h6 class="modal-title">Admin : Question Management : Relations</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>
<div class="row">
  <div class="col-12 border-bottom headersize py-2">
    <span class="px-4 my-2 path-class"> {{path}}</span>
  </div>
</div>
<div class="row">
  <div class="col-12 mx-2  d-flex">
    <div class="d-flex">
  <span
    *ngFor="let group of Groups; let i =index; "
    [ngClass]="{'selectedGroup-relation': group?.groupNumber === selectedGroup?.groupNumber}"
    (click)="onChangeRelation(group)" class="realtion-box-relation border pointer-cursor rounded mt-2">
    {{group.groupNumber}}
  </span>
    </div>
    <div class=" d-flex align-items-center">
    <span title="Add a Relation" class="my-auto position-relative" (click)="AddQuestionRelationGroup()">
      <i class="fa fa-plus-circle ms-3 plus-icon fs-2"></i>
      <i class="fa fa-info-circle position-absolute pointer-cursor"
      [title]="'To relate a question to another, double click on a question and then select the relationship from the dropdown next to the related question. Continue selecting the relationship types until all relations are established to the first question selected'"
      style="top:-3px; font-size: 19px; color:#0c4788"
      ></i>
    </span>


  </div>
  </div>
</div>
<div class="modal-body m-body pt-0 px-0">
  <div class="row">
    <div class="col-12 col-lg-12 col-xxl-6 py-2 px-2" *ngFor="let question of Questions; let i = index">
      <div class="d-flex gap-2 align-items-center">

        <!-- Question Container -->
        <div [ngClass]="getClassForQuestion(question)"
         class="flex-grow-1 bg-head-realtion px-2 pb-3 pt-2 " style="max-width: calc(100% - 120px);"
         (dblclick)="onDoubleClickTiles(question)">
         <h4 class="headertext-color-relation text-center mb-3 d-flex align-items-center justify-content-center position-relative">
          {{ question.Question_ID }}  <span style="font-size: 14px; margin-left: 10px;"> {{printQuestionDetails(question)}} </span>
          <div class="position-absolute fs-6" style="right:20px">
           <span class="me-2" *ngIf="question.Display_Order"> {{question.Display_Order}}</span>
          </div>
          <span class="position-absolute fs-6" style="left:20px" *ngIf="question.Question_Status_Type_Name">{{question.Question_Status_Type_Name}}</span>
        </h4>

          <div class="row bg-white mx-2 mt-2 q-container">
            <div class="col-12" id="question">
              <span [innerHtml]="SanitizeHTML(question?.Question_Text ?? '')"></span>
            </div>

            <div class="col-12">
              <div class="row" *ngFor="let answer of question?.AllAnswers">
                <div class="col-3 col-md-2 px-0 AnswerChoicelabel text-end text-md-end">
                  {{ answer?.Right_Answer_Ind === 'Y' ? 'Right Answer' : 'Wrong Answer' }}:
                </div>
                <div class="col-9 col-md-10 px-1 AnswerChoicelabel1">
                  <div [innerHtml]="SanitizeHTML(answer?.Answer_Choice_Text ?? '')"></div>
                </div>
              </div>
            </div>
          </div>
          <h4 class=" d-flex justify-content-between mb-0 mt-3 px-2" [ngClass]="classforCreated(question)">
            <span class=" fs-6"  *ngIf="question.Creation_Date">Created By : {{question.Created_By}}  ({{question.Creation_Date | date: 'short'}})  </span>
            <span class=" fs-6"  *ngIf="question.Creation_Date">Updated  By : {{question.Created_By}}  ({{question.Creation_Date | date: 'short'}}) </span>
          </h4>
        </div>

        <!-- Select Type Dropdown -->
        <div class="align-self-center" style="width: 120px;" *ngIf="(selectedGroup && selectedGroup.referencedQuestion) && selectedGroup?.referencedQuestion !==question.Question_ID">
          <select
          class="form-select"
          aria-label="Default select example"
          (change)="onChangeType($event, question)"
          [(ngModel)]="selectedTypeMap[question.Question_ID]"
          >
          <option
            [value]="type.Code || null"
            *ngFor="let type of QuestionRelationType">
            {{ type.Description || 'None' }}
          </option>
        </select>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class=" bl-btn btn btn-sm"
    (click)="onSave()"
  >
    Save
  </button>
  <button
    type="button"
    class=" btn btn-sm bg-light border "
    (click)="this.onCross()">
    Cancel
  </button>
</div>

